<template>
	<FormulateInput
		v-model="context.model"
		autocomplete="no"
		input-class="form-control"
		outer-class=""
		element-class="input-group"
		:name="context.name"
		:type="context.classification"
		:placeholder="context.attributes.placeholder"
		:validation="context.validation"
		:validation-name="context.validationName"
		:validation-messages="context.validationMessages"
		:step="context.attributes.step"
		:min="context.attributes.min"
		:max="context.attributes.max"
		@blur="context.blurHandler">
		<template v-if="context.attributes.icon" #prefix>
			<div class="input-group-prepend">
				<span class="input-group-text">
					<font-awesome-icon :icon="['fas', context.attributes.icon]" />
				</span>
			</div>
		</template>
	</FormulateInput>
</template>
<script>
export default {
	props: {
		context: {
			type: Object,
			required: true
		}
	},
	watch: {
		'context.model' (newValue, oldValue) {
			if (newValue === oldValue) {
				return
			}

			if (! newValue) {
				return
			}

			if (typeof newValue !== 'string') {
				return
			}

			const attr = this.context.attributes
			if (! attr.hasOwnProperty('icon')) {
				return
			}

			if (this.context.attributes.icon === 'dollar-sign')
			{
				let result = null

				const isNumber = _.find(this.context.rules, ['ruleName', 'number'])
				if (this.length(isNumber)) {
					result = newValue.replace(/[^0-9.]/g, '')
				} else {
					result = newValue.replace(/[^0-9,.]/g, '')
				}

				this.$nextTick(() => this.$set(this.context, 'model', result))
			}
		}
	},
	methods: {
		//
	}
}
</script>
